
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFA69D","width":"20","height":"20","rx":"10"}}),_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M4 4h12v12H4z"}}),_c('path',{attrs:{"d":"M13.7 7.67L12.33 6.3A1 1 0 0011 6.265l-4.5 4.5a1 1 0 00-.285.605L6 13.455a.5.5 0 00.5.545h.045l2.085-.19a1 1 0 00.605-.285l4.5-4.5A.96.96 0 0013.7 7.67zm-5.16 5.14l-1.5.14.135-1.5L10 8.66l1.35 1.35-2.81 2.8zM12 9.34L10.66 8l.975-1L13 8.365l-1 .975z","fill":"#001C45"}})])])
          )
        }
      }
    